var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-service"},[_c('div',{staticClass:"dry-service-echart"},[_c('Echart',{attrs:{"option":_vm.option,"actions":_vm.click}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }